<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Select from "@/pages/components/form/input-only/select.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, Select},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'ajaxUrl': {
			type: String,
			required: false
		},
		'options': {
			type: Array,
			default: []
		},
		'placeholder': {
			type: String,
			required: false,
		},
		'currentValueLabel': {
			type: String,
			required: false,
		},
		'tags': {
			type: Boolean,
			default: false,
		},
		'multiple': {
			type: Boolean,
			default: false,
		}
	},
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<Select
			ref="select"
			v-bind="$attrs"
			:form="form"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			:ajax-url="ajaxUrl"
			:options="options"
			:placeholder="placeholder"
			:current-value-label="currentValueLabel"
			:multiple="multiple"
			:tags="tags"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Select>
	</FormGroup>
</template>